/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CoreModule } from '@dm/core';

import { BatchConfigComponent } from './batch-config.component';
import { BatchConfigService } from './batch-config.service';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        FormsModule,
    ],
    declarations: [BatchConfigComponent],
    providers: [
        BatchConfigService,
    ],
})

export class BatchConfigModule { }
